import { MouseEvent } from "react";

export function isControlKeyPressed(event: MouseEvent) {
  return event.ctrlKey || event.metaKey;
}
